<script>
  /** @type {{item?: any}} */
  let { link = '', content = '' } = $props();

  import { platforms } from '../social-platforms';

  let encodedLink = $derived(encodeURIComponent(link));
  let encodedContent = $derived(encodeURIComponent(content));
</script>

<div class="share-buttons">
  {#each platforms as platform, i (i)}
    <a
      href={platform.link(encodedLink, encodedContent)}
      rel="noopener noreferrer"
      target="_blank"
      aria-label={platform.label}
    >
      <!-- eslint-disable-next-line svelte/no-at-html-tags -->
      {@html platform.svg}
    </a>
  {/each}
</div>
